module.exports = __webpack_public_path__ + "img/woman-filled-yellow.29e4b877.svg";